import { HERO_TWO } from 'components/SEM/constants'

export const sectionData = {
  type: HERO_TWO,
  heading: 'Connecting and creating through harmonious design',
  subheading: 'Welcome to Studio',
  buttonText: 'Build with us',
}
